// Price / VAT display helpers. VAT mode "none" = regime forfettario (no VAT);
// "plus" = price + VAT at vat_rate.
export function money(v, cur = "EUR") {
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: cur || "EUR" }).format(Number(v) || 0);
}

export function vatInfo(plan, price, lang = "it") {
  const it = lang !== "en";
  const rate = plan?.vat_rate ?? 22;
  if ((plan?.vat_mode || "none") !== "plus") {
    return { mode: "none", label: it ? "IVA non applicata (regime forfettario)" : "VAT not applied (flat-rate scheme)", total: Number(price) || 0 };
  }
  const total = (Number(price) || 0) * (1 + rate / 100);
  return { mode: "plus", rate, label: it ? `+ IVA ${rate}%` : `+ VAT ${rate}%`, total };
}

export function annualSaving(plan) {
  const m = Number(plan?.price_monthly), y = Number(plan?.price_annual);
  if (!(m > 0 && y > 0)) return null;
  const perMonth = m - y / 12;
  if (perMonth <= 0.001) return null;
  return { perMonth, monthlyEquivalent: y / 12 };
}
